























import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import { PltRichEditor } from "@szgc/plt-ui-v2";

import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "RichTextWidget",
  components: { MagicValidator, PltRichEditor }
})
export default class RichTextWidget extends WidgetBase<App.WebForm.RichTextWidget> {
  get style() {
    const style: any = {};
    style.height = this.widget.height + "px";
    return style;
  }
}
